export default __webpack_public_path__ + "static/media/3110.b0c4aff6.jpg";